import { environmentInfo } from "@shared";
import { environment } from "src/environments/environment";

export function getEnvironmentInfo() {
    const envInfo = new environmentInfo();
    envInfo.version = environment.version;
    envInfo.domain = window.location.hostname;
    // envInfo.clientIpAddress = await this.ipHelper.getClientIP();
    return Object.assign({}, envInfo);
}